import { render, staticRenderFns } from "./TransportationsComponent.vue?vue&type=template&id=507087b2&scoped=true&"
import script from "./TransportationsComponent.vue?vue&type=script&lang=js&"
export * from "./TransportationsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TransportationsComponent.vue?vue&type=style&index=0&id=507087b2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507087b2",
  null
  
)

export default component.exports